export default __webpack_public_path__ + "static/media/announcement_tab_icon.c12e770b.svg";